import { render, staticRenderFns } from "./Cinema.vue?vue&type=template&id=12f34d7d&scoped=true"
import script from "./Cinema.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cinema.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Cinema.vue?vue&type=style&index=0&id=12f34d7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f34d7d",
  null
  
)

export default component.exports